import {useListView} from '../../core/ListViewProvider'
import {HawalaBranchesListToolbar} from './HawalaBranchListToolbar'
import {HawalaBranchesListGrouping} from './HawalaBranchesListGrouping'
import {HawalaBranchesListSearchComponent} from './HawalaBranchesListSearchComponent'

const HawalaBranchesListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <HawalaBranchesListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <HawalaBranchesListGrouping /> : <HawalaBranchesListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {HawalaBranchesListHeader}
